export default [
	{
		question: '兴趣岛是一个怎样的平台？靠谱吗？',
		answer: [
			'兴趣岛成立于2016年，是聚焦大成人在线兴趣学习平台。我们已获得中国质量检验协会颁发的“全国产品和服务质量诚信品牌”认证，所有课程均公开透明定价。同时，我们推出多项行业首创保障措施，切实维护用户权益，例如 “九不做” 服务公约，致力于为用户提供安心、可靠的学习服务。',
		],
	},
	{
		question: '兴趣岛的老师水平如何？专业吗？',
		answer: [
			'兴趣岛坚守 “不名师，不开课” 的核心原则，名师选拔需满足五大核心指标：① 从业10年以上，具备行业顶尖资质；② 拥有1000+效果口碑案例；③ 有多位跟随学习 5 年以上的学员；④ 具备普世教育理念；⑤ 怀揣尊爱学员的情怀。平台汇聚了潘庆华、宋伶俐等众多行业名师，确保每一门课程都由正宗名师授课，让学员学得专业、学得放心。',
		],
	},
	{
		question: '兴趣岛的课程质量怎么样？',
		answer: [
			'兴趣岛的每一门课程均严格遵循 “六大课程特色” 进行精心打磨，即：①入门正，名师授课学名门正宗；②学得快，专业工序磨课节奏明；③效果强，百里挑一得独家方法；④很上瘾，体系环环相扣有心流；⑤真价值，兴趣变能力改变生活；⑥交学友，志趣结交交流有温度。 同时，课程出品采用兴趣岛独创的“十道工序”磨课体系，一门课程平均经历10轮以上修改，从根源上保障课程的高质量与学习效果。',
		],
	},
	{
		question: '担心学得慢或者学不会，兴趣岛有辅导吗？',
		answer: [
			'这正是我们 “三师服务”教学模式的优势。兴趣岛首创的 “三师服务” 模式以 “有温度的服务、有反馈的指导、有深度的陪伴” 为核心，具体包括：① 名师授课，负责权威课程教学；② 助教指导，负责个性化提升与作业点评；③ 班主任陪伴，提供情绪支持与学习跟踪。配套四大服务保障：当日作业当日点评，学员疑问 24 点前必回复；打造有温度的学习氛围，营内营外陪伴常在；平台全程监督，24 小时内受理诉求、48 小时内完结，助力学员实现从 “听完” 到 “学会” 的跨越。',
		],
	},
	{
		question: '兴趣岛的课程适合零基础的中老年人吗？',
		answer: [
			'我们深知中老年朋友从零开始学习的需求与挑战，因此在整个学习体系中，我们着重做好了以下三点，确保您能轻松入门、自信进阶：',
			'① 专属的适老化课程设计：所有课程均从最基础的“第一课” 教起，讲解慢而细致，适配中老年学习节奏，摒弃晦涩术语，课程内容拆解为小而明确的可操作步骤。',
			'② “三师服务”全程陪伴的教学体系：您从来都不是一个人在学习。我们通过 “名师直播授课+助教一对一答疑+班主任全程督导” 的 “三师服务”模式，为您搭建了一个有问必答、有练必评的支持系统。无论遇到任何问题，都能得到及时、耐心的指导。',
			'③ 真实的“从零到一”学员案例：许多零基础的中老年学员，在这里收获了远超技能的积极改变。例如，73岁的吴建新学员术后从零开始学习声乐，重拾了生活的快乐与信心；零基础的朴英顺学员通过我们的摄影课，学会了用镜头与世界进行新的对话。他们的改变，证明了无论起点如何，中老年朋友都能在这里找到属于自己的兴趣舞台。',
			'我们始终相信，每个兴趣都值得被点燃，人生的每个阶段都可以是崭新的开始。欢迎您随时体验，亲身感受。',
		],
	},
	{
		question: ' 兴趣岛获得过哪些权威认可？是否值得信赖？',
		answer: [
			'兴趣岛自成立以来，始终秉持稳健务实的发展理念，获得了行业与社会的广泛信赖，这份认可更集中体现在多重维度的权威资质与荣誉认定之上：在企业资质与荣誉层面，我们不仅多次获评的“广州未来独角兽创新企业”“广东省专精特新企业”，入选人民网“人民匠心服务”案例，还荣获中国质量检验协会颁发的“全国产品和服务质量诚信品牌”、百度“公信力教育品牌”等重磅奖项；',
			'在专业领域共建上，我们是中国营养学会会员单位，也是武当大学堂指定合作伙伴；在社会影响力方面，我们的实践成果多次获得《人民日报》《新华网》等主流媒体关注，其中央视《新闻直播间》更以专题形式，肯定了兴趣岛数字赋能银发群体学习的实践成果。',
			'截至目前，平台已累计荣膺80余项荣誉，并拥有134项作品著作权、29项软件著作权及16项专利，这些扎实的成果共同构成了我们专业度与公信力的坚实基础。',
		],
	},
	{
		question: ' 兴趣岛在保护用户权益方面做了哪些行业领先的举措？',
		answer: [
			'保护用户权益是我们的首要责任，为此我们推出了多项行业首创的保障措施：首先，2025 年 3 月，兴趣岛正式发布《九不做服务标准》，系行业首家对外公开发布服务标准的品牌，从根源上划定服务红线，杜绝各类损害用户权益的行为，具体包括：不做违背社会主义核心价值观的话题；不做导向不良价值观的行为；不做虚假广告夸大效果以误导用户；不做让用户借贷购买产品的行为；不做有关医疗治疗的产品服务；不做泄露、损害用户隐私的行为；不做背离企业使命的短期逐利行为；不做客单过高、服务周期过长的产品；不做违背自身信念的内容和品类。',
			'与此同时，我们全面下线花呗、白条等所有涉贷分期支付渠道，杜绝诱导超前消费。其次，我们上线全渠道体验课用户7天未服务自动退费功能，让体验更无忧。此外，我们设立400热线、线上客服、用户开放日等多重反馈渠道，并严格执行“24小时内受理，48小时内完结”的客诉处理机制，确保您的每一条心声都被认真对待。',
		],
	},
	{
		question: '作为零基础的新手，如何在兴趣岛开启兴趣学习之旅？',
		answer: [
			'兴趣岛致力于让每位兴趣爱好者都能轻松起步、收获成长。我们为您规划了清晰易懂、便捷友好的学习路径：',
			'① 多样选择，精准匹配：平台提供手机摄影、武当太极、歌唱、绘画等30门主流兴趣课程，每门课程均配有明确的学习阶段说明。您可以根据个人兴趣与目标，轻松找到入门起点。',
			'② 体验先行，放心尝试：我们为大多数课程提供体验需求。您可以通过短期实践，亲身体验课程内容、授课老师风格与教学服务质量，确认适合自己后，再决定是否进一步深入学习。',
			'③ 线上线下联动，融入兴趣生态：您还可根据自身兴趣，加入我们丰富的线下城市俱乐部、学员社群，参与手机摄影大赛、全民太极节等品牌活动，从技能学习延伸到同好交流与生活实践。',
		],
	},
];
